(function () {
  'use strict';

  function initSwatches() {
    document.querySelectorAll('.enamor-swatch__input').forEach(function (input) {
      input.addEventListener('change', function () {
        const fieldset = this.closest('.enamor-option-fieldset');
        if (!fieldset) return;
        updateSelectedState(fieldset, this);
        updateLegendValue(fieldset, this.value);
      });
    });

    document.querySelectorAll('.enamor-swatch').forEach(function (label) {
      label.addEventListener('click', function () {
        const input = this.querySelector('.enamor-swatch__input');
        if (!input || input.disabled) return;
        const fieldset = this.closest('.enamor-option-fieldset');
        updateSelectedState(fieldset, input);
        updateLegendValue(fieldset, input.value);
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function updateSelectedState(fieldset, activeInput) {
    fieldset.querySelectorAll('.enamor-swatch').forEach(function (sw) {
      sw.classList.remove('is-selected');
    });
    const parentLabel = activeInput.closest('.enamor-swatch');
    if (parentLabel) parentLabel.classList.add('is-selected');
  }

  function updateLegendValue(fieldset, value) {
    const valueEl = fieldset.querySelector('.enamor-option-value');
    if (valueEl) valueEl.textContent = value;
  }

  document.addEventListener('DOMContentLoaded', initSwatches);

  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.querySelector && node.querySelector('.enamor-swatch__input')) {
            initSwatches();
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();